import axios from "axios";
import { baseUrl } from "../utils/constants";

// Get All Users Data //
export const getUsersApi = async (userToken) => {
  return new Promise(async (resolve, reject) => {
    const url = `${baseUrl}/contractor/get-users`;

    try {
      let response = await axios.get(url, {
        headers: {
          Authorization: userToken,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      resolve(response.data);
    } catch (error) {
      console.log("api error::", error.response);
      reject(error.response);
    }
  });
};

export const getSingleUserApi = async (userToken, params) => {
  return new Promise(async (resolve, reject) => {
    const url = `${baseUrl}/contractor/get-user/${params}`;

    try {
      let response = await axios.get(url, {
        headers: {
          Authorization: userToken,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      resolve(response.data);
    } catch (error) {
      console.log("api error::", error.response);
      reject(error.response);
    }
  });
};

//  Delete user //
export const addUsersApi = async (userToken, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await axios({
        method: "POST",
        headers: {
          Authorization: userToken,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        url: `${baseUrl}/contractor/add-user`,
        data: params
      })
      resolve(response.data);
    } catch (error) {
      console.log("api error::", error.response);
      reject(error.response);
    }
  });
};

//  edit user //
export const editUsersApi = async (userToken, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await axios({
        method: "POST",
        headers: {
          Authorization: userToken,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        url: `${baseUrl}/contractor/edit-user`,
        data: params
      })
      resolve(response.data);
    } catch (error) {
      console.log("api error::", error.response);
      reject(error.response);
    }
  });
};

//  Delete user //
export const deleteUsersApi = async (userToken, params) => {
  return new Promise(async (resolve, reject) => {
    const url = `${baseUrl}/contractor/delete-users/${params}`;

    try {
      let response = await axios.get(url, {
        headers: {
          Authorization: userToken,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      resolve(response.data);
    } catch (error) {
      console.log("api error::", error.response);
      reject(error.response);
    }
  });
};

